import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { FadeIn } from 'lib/ui/components'
import { getWishlistItems, getIsFetching, getIsSuccess } from 'lib/core/data/customer/wishlist/selectors'
import { Title } from '../../components/Styled'
import { Container } from './components/Styled'
import { Item } from './components/Item'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { Link } from 'react-router-dom'

export const Wishlist = () => {
  const items = useSelector(getWishlistItems)
  const isFetching = useSelector(getIsFetching)
  const isSuccess = useSelector(getIsSuccess)
  const hasItems = !!items.length

  return (
    <>
      <FadeIn>
        <FlexWrapper className='flex-title'>
          <Title>
            My Wishlist
          </Title>
          <Link to='/customer/account'>Back</Link>
        </FlexWrapper>
      </FadeIn>

      {isFetching && !hasItems ? (
        <p>
          <FormattedMessage
            id='app.loading'
          />
        </p>
      ) : (
        <>
          {isSuccess && hasItems ? (
            <FadeIn>
              <Container>
                {items.map(item => {
                  const { id } = item
                  return (
                    <Item
                      key={id}
                      product={item.product}
                    />
                  )
                })}
              </Container>
            </FadeIn>
          ) : (
            <p>
              Your wishlist seems to be empty!
            </p>
          )}
        </>
      )}
    </>
  )
}
